import React, {FC, PropsWithChildren, ReactNode} from 'react';
import styled from 'styled-components';

import {fontSizes, fontWeights} from '../../../../../libs/shared/ui/src/styles/fontStyles';

/*
 * Styles.
 */

const StyledSection = styled.div`
  font-size: ${fontSizes.verySmall};
  color: ${(p) => p.theme.greys.shade90};
  font-weight: ${fontWeights.semibold};
  margin-bottom: 8px;
`;

const StyledDiv = styled.div`
  margin-bottom: 15px;
`;

/*
 * Props.
 */

interface SidePanelSubSectionWrapperProps {
  title: ReactNode;
  children: ReactNode;
}

/*
 * Component.
 */

export const SidePanelSubSectionWrapper: FC<PropsWithChildren<SidePanelSubSectionWrapperProps>> = ({
  title,
  children,
}) => (
  <StyledDiv>
    <StyledSection>{title}</StyledSection>
    {children}
  </StyledDiv>
);
